import React, { useContext } from 'react';
import { initPrescription, OrderContext } from '../../common/providers/ContextProvider';
import { Product, ProductTypes } from '../../utils/types';
import ProductButton from '../../common/components/ProductButton/ProductButton';
import { disabledProductHandle } from '../../config/settings';
import { ShopifyProductSearch } from '../../api';

export default function GlassesSection() {
  const { getProductIsInOrder, setOrderData, setPrescription, parentProduct } =
    useContext(OrderContext);

  const setGlasses = (glasses: Product) => {
    setPrescription(initPrescription);
    setOrderData(glasses);
  };

  const glassHandles = ShopifyProductSearch({
    parentType: parentProduct.type,
    productType: ProductTypes.Glasses,
  });
  return (
    <div>
      <h1>Velg glass</h1>
      {glassHandles.map((handle) => (
        <ProductButton
          key={handle}
          handle={handle}
          isSelected={getProductIsInOrder}
          setProduct={setGlasses}
          basePrice={parentProduct.price}
          disabled={disabledProductHandle.includes(handle)}
        />
      ))}
    </div>
  );
}
